/** Session key: one automatic reload per page address for a stale-chunk error. */
export const CHUNK_RELOAD_KEY = "route-error-boundary:chunk-reload";

/**
 * True for a failed lazy chunk. After a deploy the old chunk names are gone, so
 * a client-side navigation into a lazy route throws; a reload fetches the new ones.
 */
export const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  return (
    error.name === "ChunkLoadError" ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(error.message) ||
    /Failed to fetch dynamically imported module/i.test(error.message)
  );
};

/** Reloads once per address for a stale chunk; returns false when it already tried. */
export const reloadOnceForChunk = (href: string, reload: () => void): boolean => {
  try {
    if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === href) return false;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, href);
  } catch {
    return false;
  }
  reload();
  return true;
};
